import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Checkbox, Dropdown, Input, Radio } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    dashVodCont: boolean; dashStreamIdReq: boolean; dashRedirectMpd: boolean; dashRedirectMedia: boolean;
    dashShareConn: boolean; dashPersistConn: boolean; dashSidxNonSegTimelineMediaDur: boolean; dashSidxSegTimelineMediaDur: boolean; dashMpdGzip: boolean; dashMpdReqMode: any;
    dashInitReqMode: any; dashAutoStartComp: string; dashVarNameOptRepId: boolean; dashVarNameOptBandwidth: boolean;
    dashVarNameOptResolution: boolean; dashVarNameOptLang: boolean; dashVarNameOptType: boolean; dashAutoStartCompAllVideo: boolean;
    dashAutoStartCompAllAudio: boolean; dashAutoStartCompAllText: boolean; dashAutoStartCompLimitVideo: boolean; dashAutoStartCompLimitAudio: boolean;
    dashAutoStartCompLimitText: boolean; dashAutoStartCompLimitVideoVar: string; dashAutoStartCompLimitAudioVar: string;
    dashAutoStartCompLimitTextVar: string; dashVarNameOptPatternMatch: boolean; dashMediaFileStartPos: any; dashCookieMode: boolean; dashProfileChkMode: any;
    dashDaiEnable: boolean; dashDecrypt: boolean; dashMpdShare: boolean; dashPersistConnTimeout: any; dashRedirectMpdVariantInherit: boolean; dashVarNameOptCodec: boolean;
    dashVarNameOptSubRepBandwidth: boolean; dashVarNameOptContentComponent: boolean; dashSubRepresentationsEnable: boolean; dashImageVariantsEnable: boolean;
    dashAutoStartCompAllImage: boolean; dashAutoStartCompLimitImage: boolean; dashAutoStartCompLimitImageVar: string;
    dashAutoStartCompAllSubRep: boolean; dashAutoStartCompLimitSubRep: boolean;
}

interface Props {

}

export default class MPEGAdaptiveStreamConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            dashVodCont: false, dashStreamIdReq: false, dashRedirectMpd: false, dashRedirectMedia: false, dashShareConn: false,
            dashPersistConn: false, dashSidxNonSegTimelineMediaDur: false, dashSidxSegTimelineMediaDur: false, dashMpdGzip: false, dashMpdReqMode: '', dashInitReqMode: '',
            dashAutoStartComp: '', dashVarNameOptRepId: false, dashVarNameOptBandwidth: false, dashVarNameOptResolution: false,
            dashVarNameOptLang: false, dashVarNameOptType: false, dashAutoStartCompAllVideo: false,
            dashAutoStartCompAllAudio: false, dashAutoStartCompAllText: false, dashAutoStartCompLimitVideo: false,
            dashAutoStartCompLimitAudio: false, dashAutoStartCompLimitText: false, dashAutoStartCompLimitVideoVar: '',
            dashAutoStartCompLimitAudioVar: '', dashAutoStartCompLimitTextVar: '', dashVarNameOptPatternMatch: false, dashMediaFileStartPos: '',
            dashCookieMode: false, dashProfileChkMode: '', dashDaiEnable: false, dashDecrypt: false, dashMpdShare: false, dashPersistConnTimeout: '',
            dashRedirectMpdVariantInherit: false, dashVarNameOptCodec: false, dashVarNameOptSubRepBandwidth: false, dashVarNameOptContentComponent: false,
            dashSubRepresentationsEnable: false, dashImageVariantsEnable: false, dashAutoStartCompAllImage: false, dashAutoStartCompLimitImage: false,
            dashAutoStartCompLimitImageVar: '', dashAutoStartCompAllSubRep: false, dashAutoStartCompLimitSubRep: false
        });

        this.fetchData();
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'dashVodCont', 'dashStreamIdReq', 'dashRedirectMpd', 'dashRedirectMedia', 'dashShareConn', 'dashPersistConn',
                'dashSidxNonSegTimelineMediaDur', 'dashMpdGzip', 'dashMpdReqMode', 'dashInitReqMode', 'dashAutoStartComp', 'dashVarNameOptRepId',
                'dashVarNameOptBandwidth', 'dashVarNameOptResolution', 'dashVarNameOptLang', 'dashVarNameOptType', 'dashAutoStartCompAllVideo',
                'dashAutoStartCompAllAudio', 'dashAutoStartCompAllText', 'dashAutoStartCompLimitVideo', 'dashAutoStartCompLimitAudio',
                'dashAutoStartCompLimitText', 'dashAutoStartCompLimitVideoVar', 'dashAutoStartCompLimitAudioVar', 'dashAutoStartCompLimitTextVar',
                'dashVarNameOptPatternMatch', 'dashMediaFileStartPos', 'dashCookieMode', 'dashProfileChkMode', 'dashDaiEnable', 'dashDecrypt', 'dashSidxSegTimelineMediaDur',
                'dashMpdShare', 'dashPersistConnTimeout', 'dashRedirectMpdVariantInherit', 'dashVarNameOptCodec', 'dashVarNameOptSubRepBandwidth', 'dashVarNameOptContentComponent',
                'dashSubRepresentationsEnable', 'dashImageVariantsEnable', 'dashAutoStartCompAllImage', 'dashAutoStartCompLimitImage', 'dashAutoStartCompLimitImageVar',
                'dashAutoStartCompAllSubRep', 'dashAutoStartCompLimitSubRep'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        dashVodCont: responseObject[0].value, dashStreamIdReq: responseObject[1].value, dashRedirectMpd: responseObject[2].value,
                        dashRedirectMedia: responseObject[3].value, dashShareConn: responseObject[4].value, dashPersistConn: responseObject[5].value,
                        dashSidxNonSegTimelineMediaDur: responseObject[6].value,  dashMpdGzip: responseObject[7].value, dashMpdReqMode: responseObject[8].value,
                        dashInitReqMode: responseObject[9].value, dashAutoStartComp: responseObject[10].value,
                        dashVarNameOptRepId: responseObject[11].value, dashVarNameOptBandwidth: responseObject[12].value,
                        dashVarNameOptResolution: responseObject[13].value, dashVarNameOptLang: responseObject[14].value,
                        dashVarNameOptType: responseObject[15].value, dashAutoStartCompAllVideo: responseObject[16].value,
                        dashAutoStartCompAllAudio: responseObject[17].value, dashAutoStartCompAllText: responseObject[18].value,
                        dashAutoStartCompLimitVideo: responseObject[19].value, dashAutoStartCompLimitAudio: responseObject[20].value,
                        dashAutoStartCompLimitText: responseObject[21].value, dashAutoStartCompLimitVideoVar: responseObject[22].value,
                        dashAutoStartCompLimitAudioVar: responseObject[23].value, dashAutoStartCompLimitTextVar: responseObject[24].value,
                        dashVarNameOptPatternMatch: responseObject[25].value, dashMediaFileStartPos: responseObject[26].value,
                        dashCookieMode: responseObject[27].value, dashProfileChkMode: responseObject[28].value,
                        dashDaiEnable: responseObject[29].value, dashDecrypt: responseObject[30].value, dashSidxSegTimelineMediaDur: responseObject[31].value,
                        dashMpdShare: responseObject[32].value, dashPersistConnTimeout: responseObject[33].value,
                        dashRedirectMpdVariantInherit: responseObject[34].value, dashVarNameOptCodec: responseObject[35].value,
                        dashVarNameOptSubRepBandwidth: responseObject[36].value, dashVarNameOptContentComponent: responseObject[37].value,
                        dashSubRepresentationsEnable: responseObject[38].value, dashImageVariantsEnable: responseObject[39].value,
                        dashAutoStartCompAllImage: responseObject[40].value, dashAutoStartCompLimitImage: responseObject[41].value,
                        dashAutoStartCompLimitImageVar:  responseObject[42].value,
                        dashAutoStartCompAllSubRep: responseObject[43].value, dashAutoStartCompLimitSubRep: responseObject[44].value
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: [
                { 'name': 'dashVodCont', 'value': this.state.dashVodCont },
                { 'name': 'dashStreamIdReq', 'value': this.state.dashStreamIdReq },
                { 'name': 'dashRedirectMpd', 'value': this.state.dashRedirectMpd },
                { 'name': 'dashRedirectMedia', 'value': this.state.dashRedirectMedia },
                { 'name': 'dashShareConn', 'value': this.state.dashShareConn },
                { 'name': 'dashPersistConn', 'value': this.state.dashPersistConn },
                { 'name': 'dashSidxNonSegTimelineMediaDur', 'value': this.state.dashSidxNonSegTimelineMediaDur },
                { 'name': 'dashSidxSegTimelineMediaDur', 'value': this.state.dashSidxSegTimelineMediaDur },
                { 'name': 'dashMpdGzip', 'value': this.state.dashMpdGzip },
                { 'name': 'dashMpdReqMode', 'value': this.state.dashMpdReqMode },
                { 'name': 'dashInitReqMode', 'value': this.state.dashInitReqMode },
                { 'name': 'dashAutoStartComp', 'value': this.state.dashAutoStartComp },
                { 'name': 'dashVarNameOptRepId', 'value': this.state.dashVarNameOptRepId },
                { 'name': 'dashVarNameOptBandwidth', 'value': this.state.dashVarNameOptBandwidth },
                { 'name': 'dashVarNameOptResolution', 'value': this.state.dashVarNameOptResolution },
                { 'name': 'dashVarNameOptLang', 'value': this.state.dashVarNameOptLang },
                { 'name': 'dashVarNameOptType', 'value': this.state.dashVarNameOptType },
                { 'name': 'dashAutoStartCompAllVideo', 'value': this.state.dashAutoStartCompAllVideo },
                { 'name': 'dashAutoStartCompAllAudio', 'value': this.state.dashAutoStartCompAllAudio },
                { 'name': 'dashAutoStartCompAllText', 'value': this.state.dashAutoStartCompAllText },
                { 'name': 'dashAutoStartCompLimitVideo', 'value': this.state.dashAutoStartCompLimitVideo },
                { 'name': 'dashAutoStartCompLimitAudio', 'value': this.state.dashAutoStartCompLimitAudio },
                { 'name': 'dashAutoStartCompLimitText', 'value': this.state.dashAutoStartCompLimitText },
                { 'name': 'dashAutoStartCompLimitVideoVar', 'value': this.state.dashAutoStartCompLimitVideoVar },
                { 'name': 'dashAutoStartCompLimitAudioVar', 'value': this.state.dashAutoStartCompLimitAudioVar },
                { 'name': 'dashAutoStartCompLimitTextVar', 'value': this.state.dashAutoStartCompLimitTextVar },
                { 'name': 'dashVarNameOptPatternMatch', 'value': this.state.dashVarNameOptPatternMatch },
                { 'name': 'dashMediaFileStartPos', 'value': this.state.dashMediaFileStartPos },
                { 'name': 'dashCookieMode', 'value': this.state.dashCookieMode },
                { 'name': 'dashProfileChkMode', 'value': this.state.dashProfileChkMode },
                { 'name': 'dashDaiEnable', 'value': this.state.dashDaiEnable },
                { 'name': 'dashDecrypt', 'value': this.state.dashDecrypt },
                { 'name': 'dashMpdShare', 'value': this.state.dashMpdShare },
                { 'name': 'dashPersistConnTimeout', 'value': this.state.dashPersistConnTimeout },
                { 'name': 'dashRedirectMpdVariantInherit', 'value': this.state.dashRedirectMpdVariantInherit },
                { 'name': 'dashVarNameOptCodec', 'value': this.state.dashVarNameOptCodec},
                { 'name': 'dashVarNameOptSubRepBandwidth', 'value': this.state.dashVarNameOptSubRepBandwidth},
                { 'name': 'dashVarNameOptContentComponent', 'value': this.state.dashVarNameOptContentComponent},
                { 'name': 'dashSubRepresentationsEnable', 'value': this.state.dashSubRepresentationsEnable},
                { 'name': 'dashImageVariantsEnable', 'value': this.state.dashImageVariantsEnable},
                { 'name': 'dashAutoStartCompAllImage', 'value': this.state.dashAutoStartCompAllImage},
                { 'name': 'dashAutoStartCompLimitImage', 'value': this.state.dashAutoStartCompLimitImage},
                { 'name': 'dashAutoStartCompLimitImageVar', 'value': this.state.dashAutoStartCompLimitImageVar},
                { 'name': 'dashAutoStartCompAllSubRep', 'value': this.state.dashAutoStartCompAllSubRep},
                { 'name': 'dashAutoStartCompLimitSubRep', 'value': this.state.dashAutoStartCompLimitSubRep}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('MPEG / Dynamic Adaptive Streaming configuration applied');
                } else {
                    Toast.error('MPEG / Dynamic Adaptive Streaming configuration failed');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('MPEG / Dynamic Adaptive Streaming configuration failed');
            });
    }

    render() {
        const mpdFileReqOptions = [
            { value: 'min', text: 'Minimum Update Period'},
            { value: 25, text: '25 Media'},
            { value: 50, text: '50 Media'},
            { value: 100, text: '100 Media'}
        ];
        const initializationFileReqOptions = [
            { value: 'never', text: 'Never'},
            { value: 'init', text: 'Init'},
            { value: '100', text: '100'},
            { value: '1000', text: '1000'}
        ];
        const mediaFileStartPosOptions = [
            { value: 'auto', text: 'Auto' },
            { value: 'begin', text: 'Begin' },
            { value: 'end', text: 'End' }
        ];
        const dashProfileChkModeOptions = [
            { value: 'ignore', text: 'Ignore' },
            { value: 'warn', text: 'Warn' },
            { value: 'fail', text: 'Fail' }
        ];

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    MPEG/Dynamic Adaptive Streaming
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Streaming Options</Segment>
                                <Segment>
                                    <Form>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Play VOD Streams Continuously
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVodCont}
                                                onChange={(e: any, data: any) => this.setState({dashVodCont: data.checked})}
                                            />
                                        </Form.Group>
                                        : null}
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Include Stream Identifier Cookie In HTTP Requests
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashStreamIdReq}
                                                onChange={(e: any, data: any) => this.setState({dashStreamIdReq: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable MPD Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashRedirectMpd}
                                                onChange={(e: any, data: any) => this.setState({dashRedirectMpd: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Variants inherit MPD Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashRedirectMpdVariantInherit}
                                                onChange={(e: any, data: any) => this.setState({dashRedirectMpdVariantInherit: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Media Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashRedirectMedia}
                                                onChange={(e: any, data: any) => this.setState({dashRedirectMedia: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Shared MPD/Media Connections
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashShareConn}
                                                onChange={(e: any, data: any) => this.setState({dashShareConn: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped style={{display: 'flex', alignItems: 'center'}}>
                                            <Label className="right-align-label-width500">
                                                Enable Persistent Connections
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashPersistConn}
                                                onChange={(e: any, data: any) => this.setState({dashPersistConn: data.checked})}
                                            />
                                            <Label className={!this.state.dashPersistConn ? 'right-align-label-width170 label-disabled' : 'right-align-label-width170'}>
                                                Timeout (seconds)
                                            </Label>
                                            <Input
                                                className="small-input"
                                                disabled={!this.state.dashPersistConn}
                                                type="number"
                                                min="0"
                                                max="600"
                                                value={this.state.dashPersistConnTimeout}
                                                onChange={(e: any, data: any) => this.setState({dashPersistConnTimeout: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Decryption
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashDecrypt}
                                                onChange={(e: any, data: any) => this.setState({dashDecrypt: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Use Segment Index Box For Media Duration Non-Segment Timeline
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashSidxNonSegTimelineMediaDur}
                                                onChange={(e: any, data: any) => this.setState({dashSidxNonSegTimelineMediaDur: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Use Segment Index Box For Media Duration Segment Timeline
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashSidxSegTimelineMediaDur}
                                                onChange={(e: any, data: any) => this.setState({dashSidxSegTimelineMediaDur: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Cookies
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashCookieMode}
                                                onChange={(e: any, data: any) => this.setState({dashCookieMode: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable MPD GZIP Compression
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashMpdGzip}
                                                onChange={(e: any, data: any) => this.setState({dashMpdGzip: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable MPD Sharing
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashMpdShare}
                                                onChange={(e: any, data: any) => this.setState({dashMpdShare: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Sub-Representations
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashSubRepresentationsEnable}
                                                onChange={(e: any, data: any) => this.setState({dashSubRepresentationsEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Image Variants
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashImageVariantsEnable}
                                                onChange={(e: any, data: any) => this.setState({dashImageVariantsEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                MPD File Request Mode
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.dashMpdReqMode}
                                                options={mpdFileReqOptions}
                                                selection
                                                onChange={(event, data) => this.setState({dashMpdReqMode: data.value})}
                                            />
                                        </Form.Group>
                                        : null}
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Initialization File Request Mode
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.dashInitReqMode}
                                                options={initializationFileReqOptions}
                                                selection
                                                onChange={(event, data) => this.setState({dashInitReqMode: data.value})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Media File Start Position
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.dashMediaFileStartPos}
                                                options={mediaFileStartPosOptions}
                                                selection
                                                onChange={(event, data) => this.setState({dashMediaFileStartPos: data.value})}
                                            />
                                        </Form.Group>
                                        : null}
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Profile Check Mode
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.dashProfileChkMode}
                                                options={dashProfileChkModeOptions}
                                                selection
                                                onChange={(event, data) => this.setState({dashProfileChkMode: data.value})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <OAuth.Feature DAI>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    Enable Dynamic Ad Insertion
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.dashDaiEnable}
                                                    onChange={(e: any, data: any) => this.setState({dashDaiEnable: data.checked})}
                                                />
                                            </Form.Group>
                                        </OAuth.Feature>
                                        : null}
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Variant Name Options</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Pattern Match
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptPatternMatch}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptPatternMatch: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Representation Identifier
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptRepId}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptRepId: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Bandwidth
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptBandwidth}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptBandwidth: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Sub-Representation Bandwidth
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptSubRepBandwidth}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptSubRepBandwidth: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Resolution
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptResolution}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptResolution: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Codec
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptCodec}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptCodec: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Content Component
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptContentComponent}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptContentComponent: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Language
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptLang}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptLang: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Type
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dashVarNameOptType}
                                                onChange={(e: any, data: any) => this.setState({dashVarNameOptType: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment className="segment-header">Auto-Start Variant Streams</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Disable
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="disabled"
                                                checked={this.state.dashAutoStartComp === 'disabled'}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                All
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="all"
                                                checked={this.state.dashAutoStartComp === 'all'}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartComp: data.value})}
                                            />
                                            <Label className="right-align-label-width"/>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                label="Enable sub-representations"
                                                checked={this.state.dashAutoStartCompAllSubRep}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllSubRep: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Video
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompAllVideo}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllVideo: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Audio
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompAllAudio}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllAudio: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Text Track
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompAllText}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllText: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Image
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompAllImage}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllImage: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Limited
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="limited"
                                                checked={this.state.dashAutoStartComp === 'limited'}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartComp: data.value})}
                                            />
                                            <Label className="right-align-label-width"/>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                label="Enable sub-representations"
                                                checked={this.state.dashAutoStartCompLimitSubRep}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitSubRep: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Video Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompLimitVideo}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitVideo: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitVideo))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.dashAutoStartCompLimitVideoVar}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitVideoVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Audio Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompLimitAudio}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitAudio: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitAudio))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.dashAutoStartCompLimitAudioVar}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitAudioVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Text Track Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompLimitText}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitText: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitText))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.dashAutoStartCompLimitTextVar}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitTextVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.dashAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Image Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.dashAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.dashAutoStartCompLimitImage}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitImage: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitImage))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.dashAutoStartCompLimitImageVar}
                                                onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitImageVar: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/mpegAdaptiveStreamConfig.tsx